import { AlertDto } from '@/models/suba/alerts/AlertDTO.model';

import { createContext } from 'react';

export const AlertContext = createContext<AlertDto | undefined>(undefined);
